import "../../../css/DesignSystem/Inputs/RadioGroup.css";

const RadioGroup = ({
  name,
  label,
  options = [],
  value,
  onChange,
  error = false,
  helperText,
  required = false,
  disabled = false,
  inline = false,
  deselectable = false,
}) => {
  return (
    <div className={`ds-radio-group ${error ? "ds-radio-group--error" : ""}`}>
      {label && (
        <div className="ds-input-label FP_Content text-black">
          {label}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
        </div>
      )}
      <div
        className={`ds-radio-options ${inline ? "ds-radio-options--inline" : ""}`}
      >
        {options.map((option) => (
          <label key={option.value} className="ds-radio-option">
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={deselectable ? undefined : onChange}
              readOnly={deselectable}
              onClick={(event) => {
                if (!deselectable) return;
                event.stopPropagation();
                onChange?.({
                  target: {
                    name,
                    value: value === option.value ? "" : option.value,
                  },
                });
              }}
              disabled={disabled || option.disabled}
            />
            <span className="ds-radio-label FP_Content text-black">
              {option.label}
            </span>
          </label>
        ))}
      </div>
      {/* {helperText && (
        <div
          className={`ds-input-helper ${error ? "ds-input-helper--error" : ""}`}
        >
          {helperText}
        </div>
      )} */}
    </div>
  );
};

export default RadioGroup;
